import noneRuntime_366oeQJ1m6Yf7MfN4HAZK85uKXN_45jXod_459HfyyI5ZeDTE from '/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/node_modules/.pnpm/@nuxt+image@2.1.0_@nuxt+schema@4.6.1_@types+node@24.19.2_confbox@0.3.1_dotenv@17.4.2_gi_2e6eef459543328676feec6fe508f486/node_modules/@nuxt/image/dist/runtime/providers/none'
import gsRuntime_36IGKQ68UTtoQobjMzO4UVGq_45tFh6RJckokbF4G_45XbKlI from '/srv/projects/www.kliniken-delitzsch-eilenburg.de/api/vendors/gsmaterials/imgProvider.ts'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"none"} */
  provider: "none",
  providers: {
      ['none']: { setup: noneRuntime_366oeQJ1m6Yf7MfN4HAZK85uKXN_45jXod_459HfyyI5ZeDTE, defaults: true },
  ['gs']: { setup: gsRuntime_36IGKQ68UTtoQobjMzO4UVGq_45tFh6RJckokbF4G_45XbKlI, defaults: undefined }
  }
}
